import { render, staticRenderFns } from "./PandoraDetails.vue?vue&type=template&id=5339e857&scoped=true"
import script from "./PandoraDetails.vue?vue&type=script&lang=js"
export * from "./PandoraDetails.vue?vue&type=script&lang=js"
import style0 from "./PandoraDetails.vue?vue&type=style&index=0&id=5339e857&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5339e857",
  null
  
)

export default component.exports